import { setupDayjs } from '../util/setupDayjs';

export default defineNuxtPlugin(() => {
  const dayjs = setupDayjs();

  if (import.meta.client) {
    dayjs().format('L LT');
  }
});
